export default {
  app: {
    baseUrl: process.env.REACT_APP_API_ENDPOINT,
    defaultCountryCode: '+91'
  }
}
